"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debounce = void 0;
/**
 *
 * Creates a debounce function with a debounce and default timers
 *
 * @remarks
 * This method is a part of ui-utils in ts-common
 *
 * @param func The callback function to be called when the debounce fired.
 * @param timeout The debounce timer
 * @param defaultCallback The default timer for the default event to be fired.
 */
const debounce = (func, timeout = 500, defaultCallback = 1000) => {
    let timer;
    let defaultTimer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func(...args);
            clearTimeout(defaultTimer);
            defaultTimer = undefined;
        }, timeout);
        if (!defaultTimer) {
            defaultTimer = setTimeout(() => {
                func(...args);
                defaultTimer = undefined;
            }, defaultCallback);
        }
    };
};
exports.debounce = debounce;
